/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MonitoringLinkType {
    TABLET = 'TABLET',
    SMARTPHONE = 'SMARTPHONE',
    INTRANET = 'INTRANET',
}
